import * as React from 'react'

import { Slot } from '@radix-ui/react-slot'

import { PageHeading } from '@/components/ui/page-heading'
import { cn } from '@/lib/utils'

/** In-route title when **`PageHeader`** is not used — DESIGN_SYSTEM § Typography → **`text-2xl`**. */
type PageTitleProps = React.ComponentProps<'h2'> & {
  asChild?: boolean
}

function PageTitle({ className, asChild = false, children, id, ...titleProps }: PageTitleProps) {
  if (asChild) {
    const Comp = Slot
    return (
      <Comp
        data-slot="page-title"
        className={cn('text-2xl font-semibold tracking-tight text-foreground', className)}
        id={id}
        {...titleProps}
      />
    )
  }

  return (
    <PageHeading
      level="h2"
      id={id}
      title={children}
      titleClassName={cn('text-2xl font-semibold tracking-tight text-foreground', className)}
      titleProps={titleProps}
    />
  )
}

export { PageTitle }
